export default "__VITE_ASSET__CWzH5eM4__"